import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Client, Job, JobBoardPageComponent } from "@interfaces";
import { getDummyJobs } from "src/app/renderer/dummy-data";
import { JobsService } from "src/app/rest/jobs.service";
import { PagedResponse } from "src/app/rest/rest.service";
import { SubdomainService } from "src/app/rest/subdomain.service";
import { ComponentActionsService } from "../../services/component-actions.service";
import { AbstractComponent } from "../abstract-component";
import { JobsListComponent } from "../jobs-list/jobs-list/jobs-list.component";
import { SearchBoxComponent } from "../search-box/search-box.component";

@Component({
    selector: "app-job-board",
    templateUrl: "./job-board.component.html",
    standalone: true,
    imports: [CommonModule, SearchBoxComponent, JobsListComponent],
})
export class JobBoardComponent extends AbstractComponent implements OnInit {
    public component: JobBoardPageComponent;
    public jobs: PagedResponse<Job>;
    public loading = true;
    public client: Client;

    constructor(
        protected componentActions: ComponentActionsService,
        private jobsService: JobsService,
        private subdomain: SubdomainService,
        private route: ActivatedRoute
    ) {
        super(componentActions);
        this.subdomain.getClient().subscribe((client) => {
            this.client = client;
        });
    }

    ngOnInit(): void {
        let omitNull = (obj) => {
            Object.keys(obj || {})
                .filter((k) => obj[k] === null)
                .forEach((k) => delete obj[k]);
            return obj;
        };

        this.route.queryParams.subscribe(({ pageIndex = 0, pageSize = this.component.resultsPerPage || 10, ...query }) => {
            this.fetchJobs({ ...omitNull(query), ...omitNull(this.component.filterJobs) }, pageIndex, pageSize);
        });
    }

    private fetchJobs(query: any, pageIndex: number = 0, pageSize: number = 10) {
        delete query.previousPageIndex;
        let category = this.route.snapshot?.params?.category || this.route.snapshot.firstChild?.params?.category;

        if (this.editMode) {
            this.jobs = getDummyJobs(this.component.resultsPerPage) as unknown as PagedResponse<Job>;
            this.loading = false;
            return;
        }

        if(this.component.internalJobs) {
            query.internal = true;
        }

        if(category) {
            query.categorySlug = category;
        }

        this.loading = true;
        this.jobsService
            .find({ ...query, employer: this.client._id, published: true }, pageIndex, pageSize)
            .subscribe((result: PagedResponse<Job>) => {
                this.loading = false;
                this.jobs = result;
            });
    }

}
